// src/features/home/components/Footer.tsx

import React from 'react';
import styles from './Footer.module.scss';
import { Trans } from 'react-i18next';
import { FiUser, FiLinkedin, FiMail } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <p>
        <Trans
          i18nKey="footer.text"
          components={{
            react: (
              <a
                href="https://reactjs.org"
                className={styles.link}
                aria-label="React (opens in a new tab)"
              />
            ),
            typescript: (
              <a
                href="https://www.typescriptlang.org"
                className={styles.link}
                aria-label="TypeScript (opens in a new tab)"
              />
            ),
            zustand: (
              <a
                href="https://github.com/pmndrs/zustand"
                className={styles.link}
                aria-label="Zustand (opens in a new tab)"
              />
            ),
            vscode: (
              <a
                href="https://code.visualstudio.com"
                className={styles.link}
                aria-label="Visual Studio Code (opens in a new tab)"
              />
            ),
            netlify: (
              <a
                href="https://www.netlify.com"
                className={styles.link}
                aria-label="Netlify (opens in a new tab)"
              />
            ),
            inter: (
              <a
                href="https://rsms.me/inter/"
                className={styles.link}
                aria-label="Inter Typeface (opens in a new tab)"
              />
            ),
          }}
        />
      </p>
      <div className={styles.footerHireMeWrapper}>
        <a
          href="https://www.upwork.com/freelancers/~011243a6d19af75131"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.footerHireMeButton}
          aria-label="Hire Me on Upwork"
        >
          <FiUser className={styles.footerHireMeIcon} />
          Hire Me
        </a>
        <a
          href="https://www.linkedin.com/in/jamiljoo/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.footerHireMeButton}
          aria-label="Connect on LinkedIn"
        >
          <FiLinkedin className={styles.footerHireMeIcon} />
          LinkedIn
        </a>
        <Link
          to="/contact"
          className={styles.footerHireMeButton}
          aria-label="Contact Me"
        >
          <FiMail className={styles.footerHireMeIcon} />
          Contact
        </Link>
      </div>
    </footer>
  );
};

export default Footer;